import Link from "next/link"
import { getYear } from "date-fns"
import React from "react"

const AppFooter = ({ className }: { className?: string }) => {
  const currentYear = getYear(new Date())
  const copyrightYearRange = currentYear === 2021 ? "2021" : `2021 - ${currentYear}`

  return (
    <>
      <footer className={"footer mt-auto py-3 " + (className ?? " ")}>
        <div className="container-fluid">
          <ul className="nav justify-content-center">
            <li className="nav-item">
              <span className="nav-link disabled">
                © L&amp;A Video Consulting GmbH {copyrightYearRange}
              </span>
            </li>
            <li className="nav-item">
              <Link href={"https://playerdash.app/imprint/"} className="nav-link">
                Imprint
              </Link>
            </li>
            <li className="nav-item">
              <Link href={"https://playerdash.app/privacy-policy/"} className="nav-link">
                Privacy Policy
              </Link>
            </li>
          </ul>
        </div>
      </footer>
    </>
  )
}

export default AppFooter
